import { forwardRef } from 'react';
import SvgIcon, { type SvgIconProps } from '@material-ui/core/SvgIcon';

export const IconAiPen_16 = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  return (
    <SvgIcon
      {...props}
      ref={ref}
      viewBox="0 0 16 16"
      data-fill-none
    >
      <path
        d="M4.39014 2C4.62405 2 4.82524 2.16322 4.87029 2.38953C5.02376 3.1605 5.63833 3.7681 6.38711 3.91652C6.61987 3.96265 6.78058 4.16455 6.78008 4.39004C6.78058 4.61554 6.61987 4.81744 6.38711 4.86357C5.63827 5.012 5.02356 5.61964 4.8701 6.39055C4.82506 6.61686 4.62386 6.78008 4.38995 6.78008C4.15604 6.78008 3.95484 6.61686 3.90979 6.39055C3.75633 5.61959 3.14176 5.01199 2.39297 4.86357C2.16021 4.81744 1.9995 4.61554 2 4.39004C1.9995 4.16455 2.16021 3.96265 2.39297 3.91652C3.14181 3.76809 3.75653 3.16045 3.90998 2.38953C3.95503 2.16323 4.15623 2 4.39014 2ZM3.68457 4.39006C3.95762 4.5826 4.19658 4.82101 4.38998 5.09357C4.58342 4.82099 4.82242 4.58257 5.09552 4.39002C4.82247 4.19748 4.58351 3.95907 4.39011 3.68651C4.19667 3.95909 3.95767 4.19752 3.68457 4.39006Z"
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
      />
      <path
        d="M13.2831 6.12461L6.22494 13.1032L2.79688 14L3.69115 10.5624L10.8951 3.33858C11.5906 2.64111 12.7333 2.59129 13.4785 3.33858C14.1741 4.03605 14.1741 5.18188 13.4785 5.92917L13.2831 6.12461ZM13.2831 6.12461L10.6963 3.53784"
        stroke="currentColor"
        strokeWidth="1.19502"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
});
IconAiPen_16.displayName = 'IconAiPen_16';
